import React, { Component } from 'react'
import { TableRow, MenuItem, Button, TableCell, Chip, Input } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../../utils/common'
import { hasAccess } from '../../../utils/api'
import {
  TableCellWithTextField,
  TableCellWithSwitch,
  TableCellWithSelect,
} from '../../../components/common/PureItems'

import EditActionComponent from '../../../components/common/EditActionComponent'
import _ from 'lodash'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const renderCategorySelected = (id, categoryList) => {
  var category = _.find(categoryList, (cat) => cat.id === id)
  return category ? category.name : ''
}

export default class ChecklistListItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isUpdateCompleted !== prevProps.isUpdateCompleted &&
      this.props.isUpdateCompleted === true
    ) {
      this.props.disableEdit()
    }
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data, editMode, categoryList } = this.props
    // const categoryNameList = _.map(( categoryList, i) => {
    //   const cat = _.find(categoryList, j => j.id === i);
    //   return cat ? cat.name : "";
    // });

    return (
      <TableRow>
        <TableCellWithTextField
          valueToRender={data.name}
          editMode={editMode}
          value={data.name}
          onChange={this.onChange('name')}
          type="text"
          inputProps={{
            maxLength: 50,
          }}
        />
        <TableCellWithSelect
          valueToRender={renderCategorySelected(data.categoryId, categoryList)}
          value={data.categoryId}
          editMode={editMode}
          onChange={this.onChange('categoryId')}
        >
          {categoryList &&
            categoryList.map((category, i) => (
              <MenuItem key={i} value={category.id}>
                {category.name}
              </MenuItem>
            ))}
        </TableCellWithSelect>
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            {!editMode ? (
              <Button className="primary-button margin" onClick={this.props.onSeeDetails}>
                See tasks
              </Button>
            ) : null}
          </TableCell>
        ) : null}
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            {/* <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            /> */}
            {!editMode ? (
              <React.Fragment>
                <Button className="primary-button margin" onClick={this.props.onEdit}>
                  Edit
                </Button>
                <Button className="danger-button margin" onClick={this.props.onDelete}>
                  Delete
                </Button>
              </React.Fragment>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/ChecklistListItem.js